import React, { useEffect, useRef, useState } from "react";

// MUI Components
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { TextField, Typography } from "@mui/material";

// Assets
import { PlusIconCIcon } from "~/assets/images";

// Styles
import "./styles.scss";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const MultiSelect = (props) => {
  const {
    options,
    selectedValue,
    setSelectedValue,
    component,
    placeholder,
    mailedStatus,
    simpleSelect = false,
    noOptionText,
    enabledSearch = false,
    searchAutocomplete = false,
    setCreateTagModal = () => {},
    type,
    customIcon = false,
  } = props;
  const [menuOpen, setMenuOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);

  const handleChange = (event, isSearch = false) => {
    const {
      target: { value },
    } = event;
    if (isSearch === true || isSearch?.key === '.$searchFieldInput') return;

    if (value.includes("-1") && searchAutocomplete) {
      // Open modal if "Create New Tag" is selected
      setCreateTagModal(true);
      return;
    }

    setSelectedValue(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  const handleMenuOpen = () => {
    setMenuOpen(true);
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
  };
 
  useEffect(() => {
    let updatedOptions = options.filter((item) =>
      item?.title?.toLowerCase()?.includes(search?.toLowerCase() || "")
    );
    if (updatedOptions.length === 0 && search.trim() !== "" && searchAutocomplete && type !== "remove") {
      // If no match found, add "Create New Tag" option
      updatedOptions = [
        {
          id: "-1",
          title: "Create New Tag",
          custom: true,
          icon: PlusIconCIcon,
          func: () => setCreateTagModal(true),
        },
      ];
    }
    setFilteredOptions(updatedOptions);
  }, [search, options]);

  return (
    <FormControl className="checkboxSelectWrapper" sx={{ m: 1, width: 300 }}>
      <Select
        id="demo-multiple-checkbox"
        multiple={!simpleSelect}
        displayEmpty
        value={selectedValue}
        onChange={handleChange}
        onFocus={()=> setSearch('')}
        input={<OutlinedInput label="Tag" />}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return (
              <Typography sx={{ opacity: "0.5", fontSize: "14px" }}>
                {placeholder}
              </Typography>
            );
          }
          if (component === "multipleIds") {
            // Map back to titles for display
            return selected
              .map((id) => options.find((option) => option.id === id)?.title)
              .join(", ");
          }
          return component === "tag" || component === "updateTags"
            ? ""
            : selected.join(", ");
        }}
        MenuProps={{
          ...MenuProps,
          classes: {
            paper: component === "editUser" && "editUserMenuPaper",
          },
          MenuListProps: {
            onFocus: handleMenuOpen,
            onBlur: handleMenuClose,
            onMouseDown: (e) => e.stopPropagation(),
          },
        }}
        IconComponent={() => (
          <KeyboardArrowDownIcon
            sx={{
              color: menuOpen ? "#ED5C2F" : "inherit",
              position: "absolute",
              right: "13px",
            }}
          />
        )}
        className="statuSelect"
        sx={{
          "&.statuSelect .MuiSelect-select": {
            maxWidth:
              component === "tag" ||
              component === "contactTags" ||
              component === "updateTags"
                ? "100% !important"
                : "500px !important",
            padding: mailedStatus
              ? "14px 35px 14px 22px !important"
              : "12px 35px 12px 22px !important",
            "@media (max-width: 900px)": {
              maxWidth: "100% !important",
            },
          },
        }}
      >
        {enabledSearch && (
          <TextField
            placeholder="Search tags"
            fullWidth
            autoFocus
            onChange={(e) => setSearch(e.target.value)}
            value={search}
            autoComplete="off"
            onKeyDown={(e) => e.stopPropagation()}
            onClick={(e) => handleChange(e, true)}
            key="searchFieldInput"
            id="search"
          />
        )}

        {filteredOptions.length > 0 ? (
          filteredOptions?.map(({ id, title, disabled, icon }) => (
            <MenuItem
              disabled={disabled === true}
              key={id}
              value={
                component === "multipleIds" ||
                component === "tag" ||
                component === "updateTags"
                  ? id
                  : title
              }
              sx={{
                "&:last-child": {
                  height: "55px",
                },
              }}
            >
              {icon && customIcon ? (
                <img
                  src={icon}
                  alt="icon"
                  style={{
                    padding: "10px",
                  }}
                />
              ) : (
                !simpleSelect && (
                  <Checkbox
                    checked={
                      selectedValue.indexOf(
                        component === "multipleIds" ||
                          component === "tag" ||
                          component === "updateTags"
                          ? id
                          : title
                      ) > -1
                    }
                  />
                )
              )}
              <ListItemText
                primary={title}
                sx={
                  id === "-1" && {
                    color: "rgb(237, 92, 47)",
                  }
                }
              />
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled className="noOptionsText">
            <Typography>{noOptionText}</Typography>
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default MultiSelect;
